import React from "react";
import eventImage from "assets/images/common/others/exploreEvents.png";
import HostImage from "assets/images/common/others/attende1.png";
import { ReactComponent as ReviewGolden } from "assets/images/common/svgs/reviewGolden.svg";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";

interface Props {
  eventData: any;
}

const EventOverview = ({ eventData }: Props) => {
  const session = eventData?.event?.workshopSessions?.[0];

  const formattedFullDate = session
    ? new Intl.DateTimeFormat("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      }).format(new Date(session.startDateTime))
    : "";

  const formattedTime = session
    ? `${new Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      }).format(new Date(session.startDateTime))} - ${new Intl.DateTimeFormat(
        "en-US",
        {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        }
      ).format(new Date(session.endDateTime))}`
    : "";

  return (
    <div className="w-full lg:w-[750px]">
      <div className="mt-8 flex items-center gap-4 flex-wrap">
        {eventData?.event?.eventPicsUrl?.slice(0, 4).map((pic:any, index:number) => (
          <img
            key={index}
            className="w-[125px] h-[110px] rounded-lg object-cover"
            src={
              pic?.fileDownloadUri
                ? concatPathWithBackendUrl(pic.fileDownloadUri)
                : ""
            }
            alt={`Event image ${index + 1}`}
          />
        ))}
      </div>

      <div className="mt-8 flex flex-wrap justify-between items-center gap-4">
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">Date</span>
          <span className="text-xs text-tertiaryText">{formattedFullDate}</span>
        </div>

        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">Time</span>
          <span className="text-xs text-tertiaryText">{formattedTime}</span>
        </div>

        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Location
          </span>
          <span className="text-xs text-tertiaryText">
            {eventData?.event?.location || "-"}
          </span>
        </div>
      </div>

      <div className="mt-8 flex flex-wrap justify-between items-center gap-4">
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">About</span>
          <span className="text-xs text-tertiaryText">
            {eventData?.event?.description || "-"}
          </span>
        </div>
      </div>

      <div className="mt-8 flex flex-wrap justify-between items-center gap-4">
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Age Group
          </span>
          <span className="text-xs text-tertiaryText">
            {eventData?.event?.ageGroup
              ?.toLowerCase()
              .replace(/_/g, " ")
              .replace(/\b\w/g, (char) => char.toUpperCase())
              .replace(" To ", " to ")}
          </span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Language
          </span>
          <span className="text-xs text-tertiaryText">
            {" "}
            {eventData?.event?.language || "-"}
          </span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Skill Level
          </span>
          <span className="text-xs text-tertiaryText">
            {" "}
            {eventData?.event?.skillLevel || "-"}
          </span>
        </div>
      </div>

      <div className="flex flex-col gap-4 mt-8">
        <span className="text-sm font-semibold text-captionText">Host</span>
        <div className="border boder-lightGrayBorder rounded-lg p-3 w-[180px] flex flex-col items-center justify-center">
          <span>
            <img
              className="w-[100px] h-[100px] rounded-full "
              src={
                eventData?.host?.profilePicUrl
                  ? concatPathWithBackendUrl(
                      eventData?.host?.profilePicUrl.fileDownloadUri
                    )
                  : ""
              }
              alt="HostImage"
            />
          </span>
          <p className="font-bold text-base text-primaryText my-1">
            {eventData?.host?.firstName || "-"}{" "}
            {eventData?.host?.lastName || ""}
          </p>
          <span className="flex gap-1">
            <ReviewGolden />
            <p className="text-xs text-primaryText">{eventData?.host?.avgRating || 0}</p>
          </span>
        </div>
      </div>
    </div>
  );
};

export default EventOverview;
